// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__HZ4jt","footer":"ModalCreateQualiphyProcedure_footer__rSM_R","additionData":"ModalCreateQualiphyProcedure_additionData__2Oc49"};